var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"commercial-form"},[_c('former-form',{attrs:{"sections":_vm.sections,"loading":_vm.loading,"button":_vm.button},on:{"error":_vm.setFieldErrors,"change":_vm.setFieldValue,"edit":_vm.setField,"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }